import { render, staticRenderFns } from "./fact_collapsible_summary.vue?vue&type=template&id=432496d0&scoped=true&"
import script from "./fact_collapsible_summary.vue?vue&type=script&lang=ts&"
export * from "./fact_collapsible_summary.vue?vue&type=script&lang=ts&"
import style0 from "./fact_collapsible_summary.vue?vue&type=style&index=0&id=432496d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432496d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VLayout})
